import React from 'react'
import EditProfileContainer from '../../../../Components/Apps/Users/EditProfile'
import BorderTabs from '../../../../Components/UiKits/Tabs/BorderTabs'
import UserProfiles from '../../../../Components/Apps/Users/UserProfiles'

export default function EditProfile() {



  return (
    <div className=''>
      <EditProfileContainer />
     
    </div>
  )
}
